import React from 'react';
import blogIcon from '../../assets/icons/blog.png';

interface IconProps {
  size?: number;
  className?: string;
}

export const GoogleIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export const BlogIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <img src={blogIcon} alt="Blog" width={size} height={size} className={className} style={{ display: 'block' }} />
);

export const NaverIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="4" fill="#03C75A"/>
    <path d="M6 6v12h3.5v-6.5L14 18h4V6h-3.5v6.5L10 6H6z" fill="white"/>
  </svg>
);

export const KakaoIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="12" fill="#FEE500"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M12 6.5C8.41 6.5 5.5 8.86 5.5 11.75C5.5 13.58 6.6 15.21 8.3 16.18L7.5 19.02C7.47 19.12 7.5 19.22 7.58 19.28C7.62 19.31 7.67 19.32 7.72 19.32C7.78 19.32 7.84 19.3 7.89 19.27L11.21 17.08C11.47 17.11 11.73 17.13 12 17.13C15.59 17.13 18.5 14.77 18.5 11.88C18.5 8.99 15.59 6.5 12 6.5Z" fill="#000000"/>
  </svg>
);

export const YouTubeIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="4" fill="#FF0000"/>
    <rect x="4" y="8" width="16" height="8" rx="2" fill="white"/>
    <path d="m10 9.5 4 2.5-4 2.5v-5z" fill="#FF0000"/>
  </svg>
);

export const InstagramIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor:'#833AB4'}} />
        <stop offset="50%" style={{stopColor:'#FD1D1D'}} />
        <stop offset="100%" style={{stopColor:'#FCB045'}} />
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#instagram-gradient)"/>
    <rect x="5" y="5" width="14" height="14" rx="3" fill="none" stroke="white" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="3.5" fill="none" stroke="white" strokeWidth="1.5"/>
    <circle cx="16.5" cy="7.5" r="1" fill="white"/>
  </svg>
); 